import { createTheme } from '@mui/material/styles';
import shadows from './shadows';
import { light } from './palette';

const getTheme = (mode) =>
  createTheme({
    palette: {
      mode: light.mode,
      alternate: light.alternate,
      orange: light.orange,
      blue: light.blue,
      green: light.green,
      lightGrey: light.lightGrey,
      darkGrey: light.darkGrey,
      success: light.success,
      error: light.error,
      base: light.base,
    },
    shadows: shadows(mode),
    typography: {
      fontFamily: '"Inter", sans-serif',
      button: {
        textTransform: 'none',
        fontWeight: 'medium',
      },
      h1: {
        fontSize: '48px',
        lineHeight: 1.25,
        '@media (min-width:768px)': {
          fontSize: '72px',
        },
      },
      h2: {
        fontSize: '36px',
        lineHeight: 1.2,
        '@media (min-width:768px)': {
          fontSize: '60px',
        },
      },
      h3: {
        fontSize: '30px',
        lineHeight: 1.25,
        '@media (min-width:768px)': {
          fontSize: '48px',
        },
      },
      h4: {
        fontSize: '24px',
        lineHeight: 1.2,
        '@media (min-width:768px)': {
          fontSize: '36px',
        },
      },
      h5: {
        fontSize: '22px',
        lineHeight: 1.25,
        '@media (min-width:768px)': {
          fontSize: '30px',
        },
      },
      h6: {
        fontSize: '20px',
        lineHeight: 1.33,
        '@media (min-width:768px)': {
          fontSize: '24px',
        },
      },
      body1: {
        fontSize: '16px',
        lineHeight: 1.5,
        '@media (min-width:768px)': {
          fontSize: '20px',
        },
      },
      body2: {
        fontSize: '16px',
        lineHeight: 1.5,
        '@media (min-width:768px)': {
          fontSize: '18px',
        },
      },
      body3: {
        fontSize: '14px',
        lineHeight: 1.5,
        '@media (min-width:768px)': {
          fontSize: '16px',
        },
      },
      body4: {
        fontSize: '13px',
        lineHeight: 1.5,
        '@media (min-width:768px)': {
          fontSize: '14px',
        },
      },
      body5: {
        fontSize: '11px',
        lineHeight: 1.5,
        '@media (min-width:768px)': {
          fontSize: '12px',
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1440,
        lg: 1536,
      },
    },
    zIndex: {
      appBar: 1200,
      drawer: 1300,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            fontWeight: 400,
            borderRadius: 5,
            paddingTop: 10,
            paddingBottom: 10,
          },
          containedSecondary: mode === 'light' ? { color: 'white' } : {},
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: {
            borderRadius: '8px',
            backgroundColor: '#FFFFFF',
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ED6F3A',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#ED6F3A',
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
        },
      },
      MuiBox: {
        styleOverrides: {
          root: {
            fontFamily: '"Inter", sans-serif',
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            '&.MuiInputBase-input.MuiOutlinedInput-input.MuiSelect-select': {
              minHeight: '20px',
            },
          },
        },
      },
    },
  });

export default getTheme;
